import React, {useEffect, useRef} from 'react';
import cx from 'classnames';
import {noop} from '@ultradent/utilities/Functions';

const StickyPane = ( {children, className = '', innerPaneClassName = '', expandedOffset = 0} ) => {
    const paneNode = useRef();
    const paneInnerNode = useRef();

    /**
     * Toggle height style for facet pane to avoid offscreen scrolling when in initial state
     */
    useEffect( () => {
        if ( !paneNode.current ) {
            return noop;
        }

        const bodyRect = document.body.getBoundingClientRect();
        const containerBounds = paneNode.current.getBoundingClientRect();
        const collapse = () => {
            if ( !paneInnerNode.current ) {
                return;
            }
            paneInnerNode.current.style.height = `calc(100vh - ${containerBounds.top - bodyRect.top}px)`;
        }
        const expand = () => {
            if ( !paneInnerNode.current ) {
                return;
            }
            paneInnerNode.current.style.height = `calc(100vh - ${expandedOffset}px)`;
        };

        collapse();

        const wp = new window.Waypoint( {
            element: paneNode.current,
            handler: function ( direction ) {
                if ( direction === 'down' ) {
                    expand();
                    return;
                }
                collapse();
            }
        } );

        return () => wp.destroy();
    }, [expandedOffset] );

    return (
        <div ref={paneNode} className={className}>
            <div ref={paneInnerNode} className={cx( 'sticky overflow-auto top-0 h-screen', innerPaneClassName )}>
                {children}
            </div>
        </div>
    );
}

export default StickyPane;
